import { FC, ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { Box, Text } from '@chakra-ui/react'
import { useAuthStore } from '@/stores/authStore'

interface ProtectedRouteProps {
  children: ReactNode
}

/**
 * 認証必須ルートのガードコンポーネント。
 *
 * - 認証状態確認中はローディング表示
 * - 未認証の場合は /login にリダイレクト
 * - 認証済みの場合は children を表示
 *
 * このガードを通過した後、子コンポーネントでは user が確実に存在することが
 * 保証されるため、各ページで `if (!user) return null;` のような早期 return を
 * 書く必要はない。
 */
export const ProtectedRoute: FC<ProtectedRouteProps> = ({ children }) => {
  const { user, loading } = useAuthStore()

  if (loading) {
    return (
      <Box minH="100vh" display="flex" alignItems="center" justifyContent="center">
        <Text color="gray.500">読み込み中...</Text>
      </Box>
    )
  }

  if (!user) {
    return <Navigate to="/login" replace />
  }

  return <>{children}</>
}
